import script from "./ParentalPageError.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentalPageError.vue?vue&type=script&setup=true&lang=js"

import "./ParentalPageError.vue?vue&type=style&index=0&id=3d9b3132&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9b3132"]])

export default __exports__